import { IFieldNames as I } from "./types";

// Preserved verbatim from the current FTS form.
const emailRegexp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const phoneRegexp = /^[2-9]\d{9}$/;

/**
 * Validate-on-submit. Mirrors the current FTS form's rules and inline messages
 * exactly. Returns [isValid, updatedForm] with messages on invalid fields.
 */
export const validate = (form: any): [boolean, any] => {
  const updatedForm = { ...form };
  let isValid = true;

  const setError = (key: string, message: string) => {
    isValid = false;
    updatedForm[key] = { ...updatedForm[key], message };
  };

  // Loan amount: required (> 0), then max, then min.
  const amount = form[I.requestedLoan]?.value;
  if (!amount || +amount <= 0) {
    setError(I.requestedLoan, "This field is required");
  } else if (+amount > 2000) {
    setError(I.requestedLoan, "loan amount offers are up to $2,000");
  } else if (+amount < 300) {
    setError(I.requestedLoan, "loan amount offers are from $300");
  }

  // Reason: non-empty (trimmed).
  if (!form[I.reason]?.value?.trim()) {
    setError(I.reason, "Select a reason");
  }

  // SSN: strip mask chars, must be exactly 9 digits.
  const ssn = form[I.ssn]?.value?.trim().replace(/_/g, "");
  if (!ssn) {
    setError(I.ssn, "This field is required");
  } else if (ssn.length !== 9) {
    setError(I.ssn, "Enter a valid number");
  }

  // Email: valid format (lower-cased for the test, as in the current form).
  if (!emailRegexp.test(String(form[I.email]?.value).toLowerCase())) {
    setError(I.email, "Enter a valid email");
  }

  // Phone: 10 digits, first digit 2-9.
  if (!phoneRegexp.test(form[I.phoneNumber]?.value)) {
    setError(I.phoneNumber, "Enter a valid phone number");
  }

  return [isValid, updatedForm];
};
